import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "409px",
  },

  mobile_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "84%",
  },

  title: {
    color: "#000000",
    fontSize: "20px",
    fontWeight: 500,
    letterSpacing: 0,
  },

  description: {
    color: "#353535",
    fontSize: "16px",
    letterSpacing: 0,
    margin: "4px 0px",
  },

  img_container: {
    height: "110px",
    width: "100%",
    margin: "6px 0px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  background_img: {
    height: "100%",
    width: "100%",
    borderRadius: "4px",
  },

  slider_container: {
    width: "99%",
    marginBottom: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default useStyles;
